import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '新規追加',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 2,
  staffOnly: true,
  rolesOnly: ['admin'],
};
